import { FC } from 'react';

import {
  StyledHeader,
  StyledItem,
  StyledPanel,
  StyledRoot,
  StyledTrigger,
  TriggerChevron,
} from './Accordion.styled';
import type { AccordionItemProps, AccordionProps } from './types';

const ChevronIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 6L8 10L12 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const AccordionItem: FC<AccordionItemProps> = ({
  value,
  label,
  children,
  disabled,
  className,
  chevronPosition = 'end',
}) => {
  const chevron = (
    <TriggerChevron>
      <ChevronIcon />
    </TriggerChevron>
  );

  return (
    <StyledItem value={value} disabled={disabled} className={className}>
      <StyledHeader>
        <StyledTrigger>
          {chevronPosition === 'start' && chevron}
          {label}
          {chevronPosition === 'end' && chevron}
        </StyledTrigger>
      </StyledHeader>
      <StyledPanel>{children}</StyledPanel>
    </StyledItem>
  );
};

AccordionItem.displayName = 'Accordion.Item';

type AccordionComponent = FC<AccordionProps> & { Item: typeof AccordionItem };

const Accordion: AccordionComponent = ({ children, ...props }) => (
  <StyledRoot {...props}>{children}</StyledRoot>
);

Accordion.Item = AccordionItem;
Accordion.displayName = 'Accordion';

export default Accordion;
